/*import { Ability } from '@casl/ability'
import { getInitialAbilities } from '@/libs/acl/roles'

export default new Ability(getInitialAbilities())*/


import { Ability } from '@casl/ability'

export default new Ability()
